// src/utils/paymentLinkUtils.js

export const CARD_TYPES = [
    "WORLD", "AXESS", "MAXIMUM", "CARDFINANS", "PARAF", "ADVANTAGE", "COMBO", "BONUS", "SAGLAMKART", "STANDART"
];

export const ACCOUNT_TYPES = [
    { value: "SOLE_PROPRIETORSHIP", label: "Şahıs Şirketi" },
    { value: "JOINT_STOCK_COMPANY", label: "Anonim Şirket" },
    { value: "LIMITED_COMPANY", label: "Limited Şirket" },
    { value: "COOPERATIVE", label: "Kooperatif" },
    { value: "GENERAL_PARTNERSHIP", label: "Kolektif Şirket" },
    { value: "COMMANDITE_COMPANY", label: "Komandit Şirket" }
];

export const MAX_INSTALLMENTS = 12;

// Kart marka renklerini tanımlayalım
export const getCardBrandColor = (brand) => {
    const colors = {
        'VISA': 'primary',
        'MASTERCARD': 'warning',
        'AMERICAN_EXPRESS': 'info',
        'WORLD': 'success',
        'TROY': 'secondary',
        'MAXIMUM': 'danger',
        'AXESS': 'danger', // Örnek olarak eklenmiştir
        'CARDFINANS': 'info',
        'PARAF': 'primary',
        'ADVANTAGE': 'success',
        'COMBO': 'warning',
        'BONUS': 'danger',
        'SAGLAMKART': 'info',
        'STANDART': 'secondary',
    };
    return colors[brand] || 'dark';
};

// Kart marka isimlerini Türkçe'ye çevir
export const getCardBrandName = (brand) => {
    const names = {
        'VISA': 'Visa',
        'MASTERCARD': 'Mastercard',
        'AMERICAN_EXPRESS': 'Amex',
        'WORLD': 'World',
        'TROY': 'Troy',
        'MAXIMUM': 'Maximum',
        'AXESS': 'Axess',
        'CARDFINANS': 'CardFinans',
        'PARAF': 'Paraf',
        'ADVANTAGE': 'Advantage',
        'COMBO': 'Combo',
        'BONUS': 'Bonus',
        'SAGLAMKART': 'Sağlam Kart',
        'STANDART': 'Diğer (Banka Kartı)',
    };
    return names[brand] || brand;
};

// Backend'ten gelen verileri frontend formatına çeviren fonksiyon (Yeni Grup Modalı için)
export const convertBackendToFrontend = (installmentRates = []) => {
    const rates = {};

    installmentRates.forEach(r => {
        const brand = (r.brand ?? r.cardBrand ?? "").toUpperCase();
        if (!rates[brand]) rates[brand] = {};

        rates[brand][r.installmentCount] = {
            id: r.id ?? null,
            value: Number(r.commissionPercent ?? r.commissionRate ?? 0).toFixed(2),
            enabled: r.enabled != null ? r.enabled : true
        };
    });

    // eksikleri tamamla, default enabled=true
    CARD_TYPES.forEach(card => {
        if (!rates[card]) rates[card] = {};
        for (let i = 1; i <= MAX_INSTALLMENTS; i++) {
            if (!rates[card][i]) {
                rates[card][i] = { id: null, value: "0.00", enabled: true };
            }
        }
    });

    return rates;
};

// Frontend formatını backend'e göndermek için çeviren fonksiyon (Yeni Grup Modalı için)
export const convertFrontendToBackend = (ratesObj = {}) => {
    const list = [];

    Object.entries(ratesObj).forEach(([cardBrand, counts]) => {
        Object.entries(counts).forEach(([instCnt, { id, value, enabled }]) => {
            if (value != null && value !== "") {
                const commission = parseFloat(value);
                if (!Number.isNaN(commission)) {
                    list.push({
                        id,
                        cardBrand,
                        installmentCount: parseInt(instCnt, 10),
                        commissionPercent: commission,
                        enabled: enabled
                    });
                }
            }
        });
    });

    return list;
};

// Taksit verilerini kart türüne göre grupla (Oranları göstermek için)
export const groupInstallmentsByCard = (installmentRates) => {
    if (!installmentRates) return {};
    return installmentRates.reduce((acc, rate) => {
        if (!acc[rate.cardBrand]) acc[rate.cardBrand] = [];
        if (rate.enabled) acc[rate.cardBrand].push(rate);
        return acc;
    }, {});
};


export const CARD_BRAND_BANK_LABELS = {
    WORLD: "Yapı Kredi World",
    AXESS: "Akbank Axess",
    MAXIMUM: "İş Bankası Maximum",
    CARDFINANS: "QNB Finansbank CardFinans",
    PARAF: "Halkbank Paraf",
    ADVANTAGE: "HSBC Advantage",
    COMBO: "Ziraat Bankası Bankkart Combo",
    BONUS: "Garanti BBVA Bonus",
    SAGLAMKART: "Kuveyt Türk Sağlam Kart",
    STANDART: "Banka Kartı / Dijital Banka"
};